import React from 'react';
import { Container } from 'react-bootstrap';
import {
    IconMobile,
    IconSpeed,
    IconTarget,
    IconMessage,
    IconCart,
    IconFlask,
    IconBolt
} from '../sprint-icons';

export default function CroProblems() {
    const problems = [
        { icon: <IconMobile />, title: 'Weak Mobile UX', desc: 'Over 70% of traffic is mobile, yet most landing pages are designed desktop-first with broken mobile layouts.' },
        { icon: <IconSpeed />, title: 'Slow Landing Pages', desc: 'Every 1-second delay in load time reduces conversions by 7%. Speed is not optional — it is revenue.' },
        { icon: <IconTarget />, title: 'Poor CTA Hierarchy', desc: 'Visitors cannot find your call-to-action. Buried CTAs and competing elements destroy click-through rates.' },
        { icon: <IconMessage />, title: 'Unclear Messaging', desc: 'If visitors cannot understand your value proposition in 5 seconds, they bounce. Clarity beats cleverness.' },
        { icon: <IconCart />, title: 'Checkout Friction', desc: 'Unnecessary form fields, hidden costs, and confusing flows cause 70% of carts to be abandoned.' },
        { icon: <IconFlask />, title: 'No Experimentation', desc: 'Without systematic A/B testing, you are making decisions on guesses instead of data-driven insights.' },
    ];

    return (
        <section className="cro-problems">
            <Container>
                <div className="cro-reveal">
                    <span className="cro-section-label">The Problem</span>
                    <h2 className="cro-section-title">
                        Most eCommerce stores <span className="highlight">lose revenue</span> because of
                    </h2>
                    <p className="cro-section-subtitle">
                        These silent conversion killers cost you thousands every month — most brands don{"'"}t even know they exist.
                    </p>
                </div>

                <div className="cro-problem-grid">
                    {problems.map((item, idx) => (
                        <div className={`cro-problem-card cro-reveal cro-delay-${idx + 1}`} key={idx}>
                            <div className="problem-icon">{item.icon}</div>
                            <h4>{item.title}</h4>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>

                <div className="cro-solution-banner cro-reveal">
                    <div className="solution-icon"><IconBolt /></div>
                    <p>
                        <strong>We identify and fix these conversion bottlenecks</strong> using
                        AI-assisted CRO workflows — turning your existing traffic into significantly
                        more revenue without increasing ad spend.
                    </p>
                </div>
            </Container>
        </section>
    );
}

